import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import './MainLayout.css';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import ConfirmationModal from './ConfirmationModal';
import { useAuth } from '@workos-inc/authkit-react';
import { Tooltip } from 'react-tooltip';
import CookieBanner from './CookieBanner';

const MainLayout = () => {
  const { signOut } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogoutConfirm = () => {
    signOut();
    setIsLogoutModalOpen(false);
  };

  return (
    <div className={`dashboard-layout ${isSidebarOpen ? 'sidebar-open' : ''}`}>
      <Header
        className="dashboard-header"
        onToggleSidebar={toggleSidebar}
        onLogoutClick={() => setIsLogoutModalOpen(true)}
      />
      <Sidebar
        className="dashboard-sidebar"
        isOpen={isSidebarOpen}
        onLogoutClick={() => setIsLogoutModalOpen(true)}
      />
      <main className="dashboard-main">
        <Outlet />
      </main>
      <Footer className="dashboard-footer" />
      <CookieBanner />
      <ConfirmationModal
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        onConfirm={handleLogoutConfirm}
        title="Confirm Logout"
      >
        <p>Are you sure you want to log out?</p>
      </ConfirmationModal>
      <Tooltip id="buddy-tooltip" />
    </div>
  );
};

export default MainLayout;
